<template>
  <div class="gui-flex gui-flex-rows">
    <div class="custom-scrollbar">
      <v-card class="pt-3 pl-3 pr-3 pb-0 transparent">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <h3>Nadřízení spolupracovníci</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <div class="">
                <v-data-table
                  :headers="headers"
                  :items="items"
                  hide-controls
                >
                  <template slot="items" slot-scope="props">
                    <td><router-link :to="{ path: '/klienti/' + props.item.id }" target="_blank">{{ props.item.nazev_osoby }}</router-link></td>
                    <td>{{ props.item.telefon }}</td>
                    <td>{{ props.item.email }}</td>
                    <!--<td>{{ props.item.pozice }}</td>-->
                  </template>
                </v-data-table>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        { text: 'Jméno a příjmení', value: 'jmeno', sortable: false },
        { text: 'Telefon', value: 'telefon', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        //{ text: 'Pozice', value: 'pozice', sortable: false }
      ],
      items: [
      ]
    }
  },
  mounted: function() {
    window.API.get("osoby/"+this.$props.id+"/nadrizeni-spolupracovnici").then(function(body) {
      this.items = body;
    }.bind(this)).catch(function(err) {
      console.log(err);
    }.bind(this));
  },
  props: {
    id: String
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/NadrizeniSpolupracovnici.vue